import { render, staticRenderFns } from "./BasePanel.vue?vue&type=template&id=4719f702&scoped=true"
import script from "./BasePanel.vue?vue&type=script&lang=js"
export * from "./BasePanel.vue?vue&type=script&lang=js"
import style0 from "./BasePanel.vue?vue&type=style&index=0&id=4719f702&prod&scoped=true&lang=css"
import style1 from "./BasePanel.vue?vue&type=style&index=1&id=4719f702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4719f702",
  null
  
)

export default component.exports